import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography, colors } from '@material-ui/core';

import { stopImpersonation } from 'utils';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(0.5, 2),
        backgroundColor: colors.orange[700],
        color: theme.palette.common.white,
    },
    exit: {
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white,
    },
}));

/**
 * «Ви переглядаєте як …» — on every page while the super admin is looking
 * through somebody else (utils/Auth/impersonation.js), so it is never
 * forgotten whose name a change goes out under. Shown on the server's word
 * (/api/me `impersonator`), not on what localStorage holds.
 */
const ImpersonationBanner = () => {
    const classes = useStyles();
    const [t] = useTranslation();
    const user = useSelector(store => (store.userSession || {}).user || {});

    if (!user.impersonator) {
        return null;
    }

    return (
        <div className={classes.root} data-testid="impersonation-banner">
            <Typography variant="body2" color="inherit">
                {t('impersonation.banner', { name: user.displayName || user.username })}
            </Typography>
            <Button
                size="small"
                variant="outlined"
                className={classes.exit}
                onClick={stopImpersonation}
                data-testid="impersonation-exit"
            >
                {t('impersonation.exit')}
            </Button>
        </div>
    );
};

export default ImpersonationBanner;
